<ng-container >
    <iframe type="text/html" [src]="kcSessionUrl" width="1" height="1"></iframe>
</ng-container>